module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonerebranding-01.490d7cd0.jpg";